import { useMemo, type ComponentProps } from "react";

import type { OptionStock } from "@/lib/gql/__generated__/graphql";

import type { OptionStockTableForLaptop } from "../index";

type Props = Pick<ComponentProps<typeof OptionStockTableForLaptop>, "selectedItemIDs" | "serverModel">;

export const useOptionStockTablePresenter = ({ serverModel, selectedItemIDs }: Props) => {
	const filteredOptionStock = useMemo<OptionStock>(() => {
		const { items } = serverModel.optionStock;
		const filteredItems = items.filter((item) => selectedItemIDs.includes(item.optionID));

		return {
			...serverModel.optionStock,
			items: filteredItems,
		};
	}, [serverModel, selectedItemIDs]);

	const [currentYear, currentMonth] = useMemo(
		() => filteredOptionStock.headers[0].date.split("-"),
		[filteredOptionStock.headers],
	);

	return {
		filteredOptionStock,
		currentYear,
		currentMonth,
	};
};
